import ko from 'knockout';
import { IEmbedContainerArgs, EmbedService } from '@/apps/timeSeriesViewer/components/embeddableArtifactComponent/embedService';
import { IImageDefinition, EmbeddableContainerArgs } from '@/apps/timeSeriesViewer/components/embeddableContainer/embeddableContainer';

export interface IEmbeddableContainerArgs {
  widgetLogo: IImageDefinition;
  sponsorLogo: IImageDefinition;
  twitterMessage: string;
  twitterAccountId: string;
  socialBaseUrl: string;
}

export class EmbeddableContainerArgsFactory {
  constructor(
    private readonly _embedService: EmbedService,
    private _trendTitle: KnockoutComputed<string | null | undefined>,
    private _args: IEmbeddableContainerArgs
  ) {}

  create(): EmbeddableContainerArgs {
    const name = ko.pureComputed(() => this._trendTitle() || 'Trend');

    const embedUrl = ko.pureComputed(() => {
      const embedContainerArgs: IEmbedContainerArgs = {
        name: name(),
        style: 'height: 600px;'
      };
      return this._embedService.getEmbedUrl(embedContainerArgs);
    });

    return new EmbeddableContainerArgs(embedUrl, this._args.widgetLogo, this._args.sponsorLogo, ko.observable(false));
  }
}
